import { event, GtagEvent } from "./event";

export interface ViewSearchResults extends GtagEvent {
    search_term?:string;
}
export const view_search_results = ($_?:ViewSearchResults) => event('view_search_results',$_);